import styles from './UserCommand.module.css'
import {useSessionContext} from '../../contexts/SessionContext'
import {GitHubAvatar} from '@github-ui/github-avatar'
import {ownerAvatarPath} from '@github-ui/paths'
import {Stack} from '@primer/react'

/**
 * Presentational component for a single user message bubble with avatar.
 */
export function UserMessageBubble({content}: {content: string}) {
  const {session} = useSessionContext()
  const displayName = session.user_login ?? 'user'
  const avatarUrl = ownerAvatarPath({owner: session.user_login ?? 'ghost'})

  return (
    <Stack align="start" direction="horizontal" gap="condensed" className={styles.commandRow}>
      <span className={styles.commandBox}>{content}</span>
      <GitHubAvatar src={avatarUrl} alt={`${displayName}'s avatar`} size={28} className={styles.avatar} />
    </Stack>
  )
}
